import {Route} from '@angular/router';
import {canNotAuthGuard} from '@shared/guards/can-not-auth-guard';

export const AUTH_ROUTES: Route = {
  path: 'auth',
  canActivate: [canNotAuthGuard],
  children: [
    {
      path: 'sign-in',
      title: 'sign_in',
      loadComponent: () => import('../pages/auth/sign-in/sign-in').then((m) => m.SignIn),
    },
    {
      path: 'sign-up',
      title: 'sign_up',
      loadComponent: () => import('../pages/auth/sign-up/sign-up').then((m) => m.SignUp),
    },
    {
      path: 'sign-up',
      title: 'sign_up',
      loadComponent: () => import('../pages/auth/sign-out/sign-out').then((m) => m.SignOut),
    },
    {
      path: 'verify-email',
      title: 'verify_email',
      loadComponent: () => import('../pages/auth/verify-email/verify-email').then((m) => m.VerifyEmail),
    },
    {
      path: 'forgot-password',
      title: 'forgot_password',
      loadComponent: () => import('../pages/auth/forgot-password/forgot-password').then((m) => m.ForgotPassword),
    },
    {
      path: 'reset-password',
      title: 'reset_password',
      loadComponent: () => import('../pages/auth/reset-password/reset-password').then((m) => m.ResetPassword),
    },
    {
      path: 'sign-out',
      title: 'sign_out',
      loadComponent: () => import('../pages/auth/sign-out/sign-out').then((m) => m.SignOut),
    },
    {
      path: '',
      redirectTo: 'sign-in',
      pathMatch: 'prefix',
    },
  ],
};
